// 全站覆蓋層 Escape 統一堆疊（2026-08-13 hotfix/fix_dialog）。
// 動機：共用 Dialog 補上 Escape 關閉後，散落各處的自製下拉/popover 若沒有消費 Escape，
// 事件會冒泡到 Dialog 的監聽、把宿主彈窗一起關掉（review P1）。要求每個 caller 自己
// preventDefault 的契約守不住（盤點出 15+ 處裸奔），改為集中式：
//   單一 document keydown 監聽 + 堆疊——任何覆蓋層（Dialog / Drawer / FloatingPanel /
//   自製下拉 / popover）開啟時註冊，Escape 一律只關「最上層」並 preventDefault。
//
// 用法：在「開啟期間」的 createEffect 內一行：
//   onCleanup(registerEscapeLayer(() => setOpen(false)))
// registerEscapeLayer 回傳註銷函式，交給 onCleanup 即可（關閉/卸載自動出棧）。
//
// ⚠️ 硬性契約：註冊所在的 effect **只准追蹤 open 訊號**。堆疊順序 = 註冊順序，
// effect 若還追蹤其他訊號（含 props getter），該訊號一變就 cleanup→重註冊、跳到棧頂，
// 越過當下開著的內層浮層，Esc 會關錯層。需要跟其他依賴共存時，把註冊拆成獨立 effect
//（範例見 Dialog.jsx）。若未來有「同層原地更新」需求再擴充 owner/token API。
//
// 不需註冊的：自理 Escape 的浮層（DatePicker/CalendarRange/DateRangePicker/MultiSelect/
// SearchSelect/AddDialogNew 等）——條件是在比 document bubble 早的階段「自行消費」這次 Escape，
// preventDefault（本監聽看 defaultPrevented 跳過）或 stopPropagation（事件到不了 bubble 階段）皆可。
// 兩條路結果相同、機制不同，改動既有浮層時別把其中一種誤改成「都一樣」。
//
// 已知「未註冊也未自理」的第三類（2026-08-13 盤點）：components/MerchantTags.jsx、
// pages/Lines.jsx 與 pages/Merchants.jsx 的批次標籤下拉、pages/line/Screenshots.jsx 的
// FilterDropdown——皆只有 mousedown outside-click。目前都在頁面層、無覆蓋層宿主，Esc 只是
// 關不掉下拉（缺功能非誤關）。⚠️ 若日後把它們搬進 Dialog/Drawer，必須同時補 registerEscapeLayer，
// 否則「Esc 連宿主一起關」的 bug 會原地重現。
const layers = []

function onKeyDown(e) {
  if (e.key !== 'Escape' || !layers.length || e.defaultPrevented) return
  // 輸入法組字中不攔：注音/拼音的 Esc 是「取消組字」不是關彈窗（同 AddDialogNew 慣例；keyCode 229 是舊瀏覽器等價判斷）
  if (e.isComposing || e.keyCode === 229) return
  e.preventDefault()
  layers[layers.length - 1].close()
}

export function registerEscapeLayer(close) {
  const token = { close }
  layers.push(token)
  if (layers.length === 1) document.addEventListener('keydown', onKeyDown)
  return () => {
    const i = layers.indexOf(token)
    if (i >= 0) layers.splice(i, 1)
    if (!layers.length) document.removeEventListener('keydown', onKeyDown)
  }
}
